import React, { Component } from 'react';
import { connect } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.css';
import { NavLink } from 'react-router-dom';
import { openSignupModal } from '../../store/actions/signupModalActions';
import '../home/Home.css';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

class Header extends Component {
  constructor(props, context) {
    super(props, context);
  }

  handleOpenLoginModal = e => {
    e.preventDefault();
    this.props.openSignupModal();
  };

  handleNavigateToSignin = () => {
    this.props.history.push('/signin');
  };

  render() {
    return (
      <div className="nav-bar-holder">
        <div>
          <nav className="navbar navbar-expand-sm navbar-light">
            <button
              className="navbar-toggler bg-light"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <a className="navbar-brand landing-page-background" href="/">
              <img className="hype-pilot-logo-top" src="/images/hplogo.png" />
            </a>
            <div
              className="collapse navbar-collapse flex-grow-1 text-right"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ml-auto flex-nowrap">
                <li className="nav-item primary-font-color sliding-middle-out">
                  <NavLink
                    className="nav-link m-2 menu-item nav-active"
                    to="/for-influencers"
                  >
                    Influencers
                  </NavLink>
                </li>
                <li className="nav-item primary-font-color sliding-middle-out">
                  <NavLink
                    className="nav-link m-2 menu-item nav-active"
                    to="/for-companies"
                  >
                    Brand
                  </NavLink>
                </li>
                <li className="nav-item primary-font-color sliding-middle-out">
                  <NavLink
                    className="nav-link m-2 menu-item nav-active"
                    onClick={() => this.handleNavigateToSignin()}
                    // to="/signin"
                  >
                    Login
                  </NavLink>
                </li>
                <li className="nav-item primary-font-color">
                  <Button
                    className="nav-link m-2 menu-item nav-active"
                    onClick={this.handleOpenLoginModal}
                    className="signup-header-button"
                  >
                    Sign Up
                  </Button>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    // authError: state.auth.authError,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    openSignupModal: () => dispatch(openSignupModal())
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withRouter
)(Header);



// WEBPACK FOOTER //
// ./src/components/layout/Header.js